import React from 'react'
import PropTypes from 'prop-types'
import formatMessage from 'format-message'
import IosSwitch from 'react-ios-switch'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'

class ReaderToolbarTools extends React.Component {
  static propTypes = {
    allowAuthorTools: PropTypes.bool.isRequired,
    userRole: PropTypes.string.isRequired,
    isModal: PropTypes.bool.isRequired,
  }

  state = {
    authorToolSwitch:
      $.jStorage.get('options_advanced_edit_mode') != null
        ? $.jStorage.get('options_advanced_edit_mode')
        : false,
  }

  handleAuthorToolSwitch = () => {
    let authorToolSwitch = !this.state.authorToolSwitch
    this.setState({ authorToolSwitch: authorToolSwitch }, () => {
      if (this.state.authorToolSwitch) {
        window.setAdvancedEditMode(true)
        /* global mixpanel:true */
        mixpanel.track('Advanced edit mode enabled')
      } else {
        window.setAdvancedEditMode(false)
        mixpanel.track('Advanced edit mode disabled')
      }
    })
  }

  /**
    Helper function that returns the proper advanced edit mode label based on user role passed in
  */
  getAdvancedEditModeLabel = userRole => {
    if (userRole === 'author') {
      return formatMessage('Author Tools')
    } else if (userRole === 'editor') {
      return formatMessage('Editor Tools')
    } else {
      return formatMessage('Instructor Tools')
    }
  }

  render() {
    const authorTooltip = (
      <Tooltip id="author_tooltip">
        {formatMessage(
          `Toggle the ${this.getAdvancedEditModeLabel(
            this.props.userRole
          ).toLowerCase()} on and off`
        )}
      </Tooltip>
    )

    return (
      <div>
        {this.props.allowAuthorTools && !this.props.isModal ? (
          <div className="booktools_item">
            <OverlayTrigger placement="top" overlay={authorTooltip}>
              <div className="booktools_item_title">
                {/* NOTE: This wrapping div has the same function as the IosSwitch because it was the only way we could easily make this meet accessibility requirements. */}
                <div tabIndex={0} onClick={this.handleAuthorToolSwitch}>
                  <label>
                    <span>
                      {this.getAdvancedEditModeLabel(this.props.userRole)}
                    </span>
                    <IosSwitch
                      id="options_advanced_edit_mode"
                      onChange={this.handleAuthorToolSwitch}
                      checked={this.state.authorToolSwitch}
                      offColor="#E0E0E0"
                      className="pull-right ml-4"
                      name="Author Tools Switch"
                      onColor="#0068A8"
                      style={{ transform: 'scale(0.6)' }}
                    />
                  </label>
                </div>
              </div>
            </OverlayTrigger>
            <div className="clearfix" />
          </div>
        ) : (
          <div />
        )}
      </div>
    )
  }
}

export default ReaderToolbarTools
